import { Checkbox, ListItemIcon, ListItemText, Menu, MenuItem } from '@mui/material';
import { addTaskColumnCheckedItem, deleteTaskColumnCheckedItem } from 'app/actions/map';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
const MapTaskViewMenu = (props) => {
    const dispatch = useDispatch();
    const { taskColumnCheckedItems } = useSelector((state) => state.map);
    const { open, onClose, anchorEl } = props;
    const handleItemClick = (value) => dispatch(taskColumnCheckedItems.indexOf(value) !== -1 ? deleteTaskColumnCheckedItem(value) : addTaskColumnCheckedItem(value));
    return (React.createElement(Menu, { open: open, onClose: onClose, anchorEl: anchorEl, PaperProps: {
            sx: (theme) => ({
                marginTop: theme.spacing(1.5),
                '&:before': {
                    right: '10px',
                },
            }),
        }, anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'right',
        }, transformOrigin: {
            vertical: 'top',
            horizontal: 'right',
        }, sx: (theme) => ({
            '.MuiListItemIcon-root': {
                minWidth: '26px!important',
            },
            '.MuiCheckbox-root': {
                padding: theme.spacing(0),
                marginLeft: theme.spacing(0),
                svg: {
                    fontSize: '18px',
                },
            },
        }) }, config.mapTaskColumns.map((value, key) => (React.createElement(MenuItem, { key: key, disableRipple: true, onClick: () => handleItemClick(value.name) },
        React.createElement(ListItemIcon, null,
            React.createElement(Checkbox, { size: 'small', edge: 'start', tabIndex: -1, disableRipple: true, checked: taskColumnCheckedItems.indexOf(value.name) !== -1 })),
        React.createElement(ListItemText, null, value.label))))));
};
export default MapTaskViewMenu;
